import { useEffect, useRef, useState } from "react";
import { Link, useParams } from 'react-router-dom';
import API_URL from "../../constant/api.config";
import { connect } from "react-redux";
import { hideLoading, showLoading } from "../../actions/loaderAction";
import { deleteInquiry, getAllAdminInquiries } from "../../actions/inquiryAction";
import ReactPaginate from "react-paginate";
import LogisticInquiriesFilter from "./LogisticInquiriesFilter";
import SubHeader from "../../components/SubHeader";
import Emitter from "../../utils/Emitter";
import MediumPopup from "../../components/MediumPopup";
import CheckBox from "../../components/CheckBox";
import Select from "react-select";
import { getCountryList } from "../../actions/defaultDataAction";
import { useAuth } from "../../AuthProvider";
import {
  setAuthHeaders,
  showErrorMessage,
  showSuccessMessage,
  convertUTCToTzDate,
  buildPath
} from "../../utils/common";
import axiosHttp from "../../axiosHttp";
import ButtonAdminpanel from "../../components/ButtonAdminpanel";
import ButtonCancell from "../../components/ButtonCancell";
import errorMessages from "../../constant/errorMessages";
import { cloneDeep, filter, isArray, isEmpty, join, map, size, trim } from "lodash";
import NoDataFound from "../../components/common/NoDataFound";
import ToolipsCustom from "../../components/ToolipsCustom";
import LogisticInquiry from "../../components/inquiry/LogisticInquiry";
import roles from "@/constant/roles.config";
import { privateRoutePaths } from "@/routes/private.route.config";
import SmallPopup from "@/components/SmallPopup";
import defaultValues from '@/constant/defaultValues';

const LogisticInquiries = (props) => {
  const { user, isSuperAdmin, isDemoUser, isViewer, isPreKYCUser, isEndUser, isInqUser, isAdmin } = useAuth();

  const { fordate } = useParams();
  const [cKey, setCkey] = useState(0);
  const [fdate, setFdate] = useState(null);

  const [allInquiries, setAllInquiries] = useState([]);
  const [pagination, setPagination] = useState([]);
  const [limit, setLimit] = useState(8);
  const [current_page, setCurrentPage] = useState(1);
  const [searchFilterObj, setSearchFilterObj] = useState({
    filter_val: null,
    findWhom: "All",
    inq_type: "All",
    selected_country: null,
    startDate: null,
    endDate: null
  });
  const [tableKey, setTableKey] = useState(0);

  const [mediummodalShow, setMediumModalShow] = useState(false);
  const [smallmodalShow, setSmallModalShow] = useState(false);
  const [selectedInquiry, setSelectedInquiry] = useState(null);

  const [countryList, setCountryList] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);

  const [companyList, setCompanyList] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const headers = setAuthHeaders();

  const [formData, setFormData] = useState({
    country_assign: "",
    company: "",
  });
  const [errors, setErrors] = useState({});
  const [isButtonDisabled, setisButtonDisabled] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const [inqModalShow, setInqModalShow] = useState(false);
  const [inqType, setInqType] = useState("LOG_PTR");
  const [memberOptLoader, setMemberOptLoader] = useState(false);

  const [assignedCompanyAndCountry, setAssignedCompanyAndCountry] = useState([{
    company: null,
    country: null,
    companyList: []
  }]);

  const [deleteInqId, setDeleteInqId] = useState();

  const { IMAGE_PATH } = defaultValues;
  const PATH = IMAGE_PATH.BASE_URL;

  const showPickupAddress = ['EXW (Ex-Works or Ex-Warehouse)', 'FCA (Free to Carrier)'];
  const showDeliveryAddress = ['CPT (Carriage Paid To)', 'CIP (Carriage And Insurance Paid To)', 'DAP (Delivered At Place)', 'DDP (Delivered Duty Paid)'];

  const getPrefix = () => {
    if (user && isPreKYCUser) return roles.PRE_KYC.prefix;
    if (user && isDemoUser) return roles.DEMO.prefix;
    if (user && isEndUser) return roles.END_USER.prefix;
    if (user && isViewer) return roles.VIEWER.prefix;
    return roles.SUPER_ADMIN.prefix;
  };

  const getAllInquiries = async (limit, current_page, filterObj) => {
    await props.showLoading();
    await props
      .getAllInquiries(limit, current_page, filterObj)
      .then((response) => {
        setAllInquiries(response.data);
        setPagination(response.pagination);
      })
      .catch((err) => {
        console.log("Error ==== ", err);
        showErrorMessage("Something Went Wrong!!");
      });
    await props.hideLoading();
  };

  const [itemOffset, setItemOffset] = useState(0);

  const endOffset = itemOffset + limit;
  // const currentItems = allInquiries.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(pagination.total / limit);

  const handlePageClick = (event) => {
    getAllInquiries(limit, event.selected + 1, searchFilterObj);
    // const newOffset = (event.selected * limit) % allInquiries.length;
    // setItemOffset(newOffset);
  };

  const setInquiriesFilters = (newState) => {
    props.showLoading();
    newState.table_search = "";
    newState.current_page = 1;
    setCurrentPage(1);
  };

  const filterApplyOnInquiries = (filterObj) => {
    setSearchFilterObj(filterObj);
    getAllInquiries(limit, current_page, filterObj);
    setTableKey((prev) => prev + 1);
    props.hideLoading();
  };

  useEffect(() => {
    //console.log("props =========== ", props);
    //getAllInquiries(limit, current_page, searchFilterObj);
  }, []);

  const safeParse = (data) => {
    if (!data) return "-";
    if (typeof data !== "string") return data; // If it's already an array, object, or number, return it directly
    try {
      return JSON.parse(data);
    } catch (e) {
      return data; // Fallback to raw string if it's not valid JSON
    }
  };

  const handlePopupShow = (inquiry) => {

    console.log("View Pop up Inquiry Details ==== ", inquiry, "-----------------------", inquiry.assign_to);

    if (inquiry.freight_type == "Air") {
      const parsedLwh = safeParse(inquiry.lwh);
      const parsedContainers = safeParse(inquiry.no_of_containers);
      const parsedCbpp = safeParse(inquiry.cbpp);

      let lwh_noqty_cbpp = [];

      if (isArray(parsedLwh)) {
        for (let i = 0; i < parsedLwh.length; i++) {
          lwh_noqty_cbpp.push({
            lwh: parsedLwh[i],
            // Fallback to value if matching index doesn't exist or parsedContainers isn't an array
            no_qty: Array.isArray(parsedContainers)
              ? parsedContainers[i]
              : parsedContainers,
            cbpp: Array.isArray(parsedCbpp) ? parsedCbpp[i] : parsedCbpp,
          });
        }
        inquiry.lwh_qty_cbpp = lwh_noqty_cbpp;
      } else {
        inquiry.lwh_qty_cbpp = [
          {
            lwh: parsedLwh,
            no_qty: parsedContainers,
            cbpp: parsedCbpp,
          },
        ];
      }
    }

    setSelectedInquiry(inquiry);
    setMediumModalShow(true);
    if (isEmpty(inquiry.assign_to)) {
      console.log("if =================")
      setIsChecked(true);
      setSelectedCompany(null);
      setAssignedCompanyAndCountry([{
        company: null,
        country: null,
        companyList: []
      }])
      setFormData((prevalue) => {
        return {
          ...prevalue,
          company: "",
        };
      });
    } else {
      console.log("Else =================")
      setAssignedCompanyAndCountry(inquiry.assign_to);
      setIsChecked(true);
      setSelectedCompany(null);
      setSelectedCountry(null);
      setFormData((prevalue) => {
        return {
          ...prevalue,
          company: "",
          country_assign: "",
        };
      });
    }

    setErrors({});
  };

  const getCompanyListBasedOnCountry = async (countryId) => {
    let country = "";
    let inquiry_for = "";
    if (selectedInquiry) {
      let type = selectedInquiry.type;
      if (type === "Logistic_Partner") {
        country = selectedInquiry.country_to;
        inquiry_for = "LOG_PTR";
      }
    }

    setFormData((prevalue) => {
      return {
        ...prevalue,
        country_assign: countryId,
      };
    });

    await axiosHttp
      .post(
        API_URL + "/get-company",
        { country: countryId, inquiry_for: inquiry_for, search: "NO" },
        {
          headers,
        }
      )
      .then((response) => {
        if (response.status === 200) {
          if (response.data.status === true) {
            const options = response.data.data.map((ct) => ({
              value: ct.id,
              label: ct.company_list_name,
              email: ct.email
            }));
            setCompanyList(options);
          }
        }
      })
      .catch((err) => {
        console.log("Error ============= ", err);
      });
  }

  // const handleCountryChange = async (cval) => {
  //   setSelectedCompany(null);
  //   setSelectedCountry(cval);
  //   const countryId = cval.label;
  //   getCompanyListBasedOnCountry(countryId);
  // };

  const handleAssignCountryChangeByIndex = async (val, indx) => {

    let inquiry_for = "";
    console.log("val ===========", val);
    if (selectedInquiry) {
      let type = selectedInquiry.type;
      if (type === "Logistic_Partner") {
        inquiry_for = "LOG_PTR";
      }
      if (type === "Supplier") {
        inquiry_for = "SUPPLIER";
      }
    }

    let cntcompObj = [...assignedCompanyAndCountry];

    let countryObj = {
      label: val.label,
      value: val.value
    }
    cntcompObj[indx]['country'] = countryObj;
    cntcompObj[indx]['companyList'] = [];

    setMemberOptLoader(true);

    let cList = await getCompaniesByCountry(
      val.label, inquiry_for, "NO", ""
    );
    cntcompObj[indx]['companyList'] = cList;

    setAssignedCompanyAndCountry(cntcompObj);
    setMemberOptLoader(false);

    let tmpObj = cloneDeep(cntcompObj);
    delete tmpObj[indx]['companyList'];
    setFormData((prev) => {
      return {
        ...prev,
        company_obj: tmpObj
      }
    })
  }

  // const handleCompanyChange = (cval) => {
  //   setSelectedCompany(cval);
  //   let companyId = cval.value;

  //   setFormData((prevalue) => {
  //     return {
  //       ...prevalue,
  //       company: companyId,
  //     };
  //   });
  // };

  const handleAssignCompanyChangeByIndex = (val, indx) => {

    let cntcompObj = [...assignedCompanyAndCountry];
    //cntcompObj[indx]['member_id'] = val.value;
    let companyObj = {
      label: val.label,
      value: val.value
    }
    cntcompObj[indx]['company'] = companyObj;
    cntcompObj[indx]['assign_to'] = val.value;
    setAssignedCompanyAndCountry(cntcompObj);
    setFormData((prev) => {
      return {
        ...prev,
        company_obj: cntcompObj
      }
    })
    // let newcntcompObj = cloneDeep(cntcompObj);

    // delete newcntcompObj[indx]['companyList'];
    // delete newcntcompObj[indx]['country'];
    // delete newcntcompObj[indx]['company'];

    // newcntcompObj = filter(newcntcompObj);

    // setFormData((prev) => {
    //   return {
    //     ...prev,
    //     country_obj: newcntcompObj
    //   }
    // });
  }


  const fetchCountries = async () => {
    await props
      .getCountryList()
      .then((data) => {
        const options = data.map((country) => ({
          value: country.id,
          label: country.name,
          countryCode: country.iso2,
        }));
        setCountryList(options);
      })
      .catch((err) => {
        console.log("Error >>>> ", err);
      });
  };

  const getCompaniesByCountry = (country, inquiry_for, search = "NO", search_txt = "") => {

    return new Promise(async (resolve, reject) => {
      await axiosHttp
        .post(
          API_URL + "/get-company",
          { country: country, inquiry_for: inquiry_for, search: search, search_txt: search_txt },
          {
            headers,
          }
        )
        .then((response) => {
          if (response.status === 200) {
            if (response.data.status === true) {
              const options = response.data.data.map((ct) => ({
                value: ct.id,
                label: ct.company_list_name,
                email: ct.email
              }));
              //return options;
              resolve(options);
            }
          }
        })
        .catch((err) => {
          console.log("Error ============= ", err);
        });
    });

  }

  const setCompanyAndCountry = async (selectedInquiry) => {
    let country = "";
    let inquiry_for = "";

    if (selectedInquiry) {
      let type = selectedInquiry.type;
      if (type === "Logistic_Partner") {
        country = selectedInquiry.country_to;
        inquiry_for = "LOG_PTR";
      }
      if (type === "Supplier") {
        country = selectedInquiry.country;
        inquiry_for = "SUPPLIER";
      }
    }

    if (selectedInquiry.assign_to == null) {
      setIsChecked(true);
      const normalizedCountry = country.trim().toLowerCase();
      const selectedCountryOption = countryList.find(
        (option) => option.label.toLowerCase().trim() === normalizedCountry
      );

      if (selectedCountryOption) {
        setSelectedCountry(selectedCountryOption);
      }

      setFormData((prevalue) => {
        return {
          ...prevalue,
          country_assign: country,
        };
      });

      await axiosHttp
        .post(
          API_URL + "/get-company",
          { country: country, inquiry_for: inquiry_for, search: "NO" },
          {
            headers,
          }
        )
        .then((response) => {
          if (response.status === 200) {
            if (response.data.status === true) {
              const options = response.data.data.map((ct) => ({
                value: ct.id,
                label: ct.company_list_name,
                email: ct.email
              }));
              setCompanyList(options);
            }
          }
        })
        .catch((err) => {
          console.log("Error ============= ", err);
        });
    } else {
      // Assign to not blank

      setIsChecked(true);
      let tmpAssignedCompanyCountry = [...assignedCompanyAndCountry];
      let tmp2 = [...assignedCompanyAndCountry];
      for (const [key, val] of tmpAssignedCompanyCountry.entries()) {
        if (val.assign_tomembers) {
          let country_id = val.assign_tomembers.country_id;

          const selectedCountryOption = countryList.find(
            (option) => option.value === country_id
          );

          tmpAssignedCompanyCountry[key]['country'] = selectedCountryOption;
          tmp2[key]['country'] = selectedCountryOption;

          let cList = await getCompaniesByCountry(
            selectedCountryOption.value,
            inquiry_for,
            "YES",
            val.assign_tomembers.member_unique_number
          );

          let member_id = val.assign_tomembers.id;
          tmpAssignedCompanyCountry[key]['companyList'] = cList;
          tmpAssignedCompanyCountry[key]['company'] =
            cList.find((option) => option.value === member_id);

          tmp2[key]['company'] = cList.find((option) => option.value === member_id);
          tmp2[key]['assign_to'] = member_id;
        }
      }

      setAssignedCompanyAndCountry(tmpAssignedCompanyCountry);

      setFormData((prev) => {
        return {
          ...prev,
          company_obj: tmp2
        }
      })
    }
  };

  const handleInputChange = (newValue) => {
    console.log("newValue >>>>>>>>", newValue, "  selectedCountry ========== ", selectedCountry)
    if (newValue !== "" && selectedInquiry && selectedCountry) {
      let inquiry_for = "";
      if (selectedInquiry) {
        let type = selectedInquiry.type;
        if (type === "Logistic_Partner") {
          inquiry_for = "LOG_PTR";
        }
      }

      if (newValue.length >= 3) {
        setCompanyList([]);
        setMemberOptLoader(true);
        axiosHttp
          .post(
            API_URL + "/get-company",
            {
              search_txt: newValue,
              country: selectedCountry.value,
              inquiry_for: inquiry_for,
              search: "YES",
            },
            { headers }
          )
          .then((response) => {

            if (response.status === 200) {
              setMemberOptLoader(false);
              if (response.data.status === true) {
                if (!isEmpty(response.data.data)) {
                  const options = response.data.data.map((ct) => ({
                    value: ct.id,
                    label: ct.company_list_name,
                    email: ct.email
                  }));
                  setCompanyList(options);
                } else {
                  setMemberOptLoader(true);
                  axiosHttp
                    .post(
                      API_URL + "/get-company",
                      {
                        country: selectedCountry.label,
                        inquiry_for: inquiry_for,
                        search: "NO",
                      },
                      {
                        headers,
                      }
                    )
                    .then((response) => {
                      setMemberOptLoader(false);
                      if (response.status === 200) {
                        if (response.data.status === true) {
                          const options = response.data.data.map((ct) => ({
                            value: ct.id,
                            label: ct.company_list_name,
                            email: ct.email
                          }));
                          setCompanyList(options);
                        }
                      }
                    })
                    .catch((err) => {
                      console.log("Error ============= ", err);
                    });
                }
              }
            }
          });
      }
      // else {
      // setCompanyList([]);
      // setSelectedCompany(null);
      // setCompanyAndCountry(selectedInquiry);
      // }
    } else {
      getCompanyListBasedOnCountry(formData.country_assign);
    }

    // if(isEmpty(selectedCompany)){
    //   setCompanyList([]);
    // }
  };

  const handleInputChangeByIndex = (newValue, indx) => {

    let tmpAssignedCompanyCountry = [...assignedCompanyAndCountry];
    console.log("newValue >>>>>>>>>>>>>>>.", newValue, " =============== ", tmpAssignedCompanyCountry);
    if (newValue !== "" && selectedInquiry && tmpAssignedCompanyCountry && tmpAssignedCompanyCountry[indx]['country']) {
      let inquiry_for = "";
      if (selectedInquiry) {
        let type = selectedInquiry.type;
        if (type === "Logistic_Partner") {
          inquiry_for = "LOG_PTR";
        }
        if (type === "Supplier") {
          inquiry_for = "SUPPLIER";
        }
      }


      if (newValue.length >= 3) {

        //setCompanyList([]);
        setMemberOptLoader(true);
        axiosHttp
          .post(
            API_URL + "/get-company",
            {
              search_txt: newValue,
              country: tmpAssignedCompanyCountry[indx]['country']['value'],
              inquiry_for: inquiry_for,
              search: "YES",
            },
            { headers }
          )
          .then((response) => {

            if (response.status === 200) {
              setMemberOptLoader(false);
              if (response.data.status === true) {
                if (!isEmpty(response.data.data)) {
                  const options = response.data.data.map((ct) => ({
                    value: ct.id,
                    label: ct.company_list_name,
                    email: ct.email
                  }));
                  // setCompanyList(options);
                  tmpAssignedCompanyCountry[indx]['companyList'] = options;
                  setAssignedCompanyAndCountry(tmpAssignedCompanyCountry);
                } else {
                  setMemberOptLoader(true);
                  axiosHttp
                    .post(
                      API_URL + "/get-company",
                      {
                        country: tmpAssignedCompanyCountry[indx]['country']['label'],
                        inquiry_for: inquiry_for,
                        search: "NO",
                      },
                      {
                        headers,
                      }
                    )
                    .then((response) => {
                      setMemberOptLoader(false);
                      if (response.status === 200) {
                        if (response.data.status === true) {
                          const options = response.data.data.map((ct) => ({
                            value: ct.id,
                            label: ct.company_list_name,
                            email: ct.email
                          }));
                          // setCompanyList(options);
                          tmpAssignedCompanyCountry[indx]['companyList'] = options;
                          setAssignedCompanyAndCountry(tmpAssignedCompanyCountry);
                        }
                      }
                    })
                    .catch((err) => {
                      console.log("Error ============= ", err);
                    });
                }
              }
            }
          });
      }
      // else {
      // setCompanyList([]);
      // setSelectedCompany(null);
      // setCompanyAndCountry(selectedInquiry);
      // }
    } else {
      getCompanyListBasedOnCountry(formData.country_assign);
    }
  }

  const customFilter = (option, searchTxt) => {
    if (option.data.email.toLowerCase().includes(searchTxt.toLowerCase())) {
      return true;
    } else if (option.data.label.toLowerCase().includes(searchTxt.toLowerCase())) {
      return true;
    } else {
      return false;
    }
  }

  const handleAddClick = () => {
    setAssignedCompanyAndCountry((prev) => {
      return [...prev, { country: null, company: null, companyList: [], inquiry_id: selectedInquiry.id }];
    });

  }

  const handleRemoveClick = (e, index) => {
    let cntcompObj = [...assignedCompanyAndCountry];
    delete cntcompObj[index];
    cntcompObj = filter(cntcompObj);
    if (isEmpty(cntcompObj)) {
      cntcompObj[0] = { country: null, company: null, companyList: [], inquiry_id: selectedInquiry.id }
    }
    setAssignedCompanyAndCountry(cntcompObj);

    setFormData((prev) => {
      return {
        ...prev,
        company_obj: cntcompObj
      }
    });
    // let er = { ...errors };
    // let companyError = er.countryCompany;
    // if (companyError) {
    //   delete companyError[index];
    //   companyError = filter(companyError);
    //   er.countryCompany = companyError;
    //   setErrors(er);
    // }
  }

  const handleCancelClick = (e) => {
    e.preventDefault();
    setMediumModalShow(false);
  };

  const validation = () => {

    let er = { ...errors };
    let isValid = true;

    er.countryCompany = [];

    map(assignedCompanyAndCountry, (item, key) => {
      if (!er.countryCompany[key]) {
        er.countryCompany[key] = {};
      }

      if (item.country === null || item.country.value <= 0) {
        er.countryCompany[key].country = errorMessages.FIELD_REQUIRED;
        isValid = false;
      } else {
        er.countryCompany[key].country = "";
      }

      if (!item.assign_to || item.assign_to <= 0) {
        er.countryCompany[key].company = errorMessages.FIELD_REQUIRED;
        isValid = false;
      } else {
        er.countryCompany[key].company = "";
      }
    });

    setErrors(er);

    if (!isValid) {
      return false;
    }

    return true;

  };

  const handleInquirySubmit = async (e) => {
    e.preventDefault();
    console.log(">>>>>>>>>>>>>>>>", formData);
    if (validation()) {
      try {
        setisButtonDisabled(true);
        await axiosHttp
          .post(
            API_URL + "/assign-company-inquiry",
            { formData, selectedInquiry: selectedInquiry },
            {
              headers,
            }
          )
          .then((response) => {
            if (response.data.status === true) {
              getAllInquiries(limit, current_page, searchFilterObj);
              setTimeout(() => {
                setisButtonDisabled(false);
                setMediumModalShow(false);
              }, 1000);
              showSuccessMessage("Inquiry Assign Successfully!");
            } else {
              setisButtonDisabled(false);
              setErrors({});
              const errors = {};
              if (response.data.error.country_assign) {
                errors.country_assign = response.data.error.country_assign;
              }
              if (response.data.error.company) {
                errors.company = response.data.error.company;
              }

              setErrors(errors);
              return Object.keys(errors).length > 0;
            }
          })
          .catch((error) => {
            setisButtonDisabled(false);
            console.error("Error fetching data:", error);
          });
      } catch (err) {
        console.error(err);
      }
    }
  };

  const styleError = {
    display: "block",
  };

  const handleCheckChange = () => {
    setIsChecked(!isChecked);
    if (isChecked === false) {
      setIsChecked(true);
      setSelectedCompany(null);
      setSelectedCountry(null);
      setErrors({});
      if (selectedCountry === null) {
        setCompanyList([]);
      }
      setFormData((prevalue) => {
        return {
          ...prevalue,
          company: "",
          country_assign: "",
        };
      });

    }

  };

  const handleInquiryClick = () => {
   
    setInqType("LOG_PTR");
    setInqModalShow(true);
  }

  const handleDeleteInquiry = async (inq) => {

    if (inq) {
      let inqId = inq.id;
      setDeleteInqId(inqId);
      setSmallModalShow(true);
      /*await props.deleteInquiry(inqId).then((data) => {
        console.log("Data ==== ", data);
        showSuccessMessage("Inquiry Deleted Successfully!");
        getAllInquiries(limit, 1, searchFilterObj);
      }) */
    }
  }

  const handleConfirmDeleteClick = () => {
    props
      .deleteInquiry(deleteInqId)
      .then((response) => {
        if (response.status === true) {
          showSuccessMessage("Inquiry Deleted Successfully!");
          setCurrentPage(1);
          setLimit(8);
          getAllInquiries(limit, 1, searchFilterObj);
          setTableKey((prev) => prev + 1);
        }
        setSmallModalShow(false);
      })
      .catch((err) => {
        console.log("Error == ", err);
        showErrorMessage("Something Went Wrong!!");
      });
  };

  useEffect(() => {
    if (selectedCountry === null) {
      setCompanyList([]);
    }
  }, [selectedCountry]);

  useEffect(() => {
    if (selectedInquiry) {
      setCompanyAndCountry(selectedInquiry);
    }
  }, [selectedInquiry]);

  useEffect(() => {
    Emitter.on("FILTER_INQUIRIES", filterApplyOnInquiries);
    Emitter.on("SET_FILTER_INQUIRIES", setInquiriesFilters);
    return () => {
      Emitter.off("FILTER_INQUIRIES", filterApplyOnInquiries);
    };
  }, []);

  useEffect(() => {
    fetchCountries();
  }, []);


  const handleDownload = (filename) => {
    const link = document.createElement("a");
    link.href = filename;
    link.download = filename;
    link.target = "_blank";
    link.click();
  };

  useEffect(() => {
    if (fordate !== undefined) {
      let fdate = atob(fordate);
      console.log("fdate ============== ", fdate)
      setFdate(fdate);
      setCkey((prev) => prev + 1);
    } else {
      setFdate(null);
      setCkey((prev) => prev + 1);
    }
  }, [fordate]);

  return (
    
        <div className="data-table-main" key={cKey}>
        <SubHeader
            layer1="Logistic Inquiries"
            layer2=""
            layer3="List"
            pageName="Logistic Inquiries"
            clickable={{
            layer1: "",
            layer2: "",
            layer3: "",
            }}
        />

      <div className="send-receive-inquiry">


        <LogisticInquiriesFilter handleClick={handleInquiryClick} fordate={props && props.fordate} pageName="LOGISTIC_INQUIRIES" />

        <div className="p-0 border bg-white rounded card-shadow mt-3 send-receive-table">
          {/* <h5 className="table-text p-3">Inquiry Lists</h5> */}
          <div className="table-wrape">
            <table className="simple-table list-table" width="100%">
              <thead>
                <tr>
                  <th className="id">ID</th>
                  <th className="name">Name</th>
                  <th className="assign_id">Assign to</th>
                  <th className="created-at">Created At</th>
                  <th className="contact-info">Contact Info</th>
                  <th className="contact-info">Type</th>
                  <th className="action">Action</th>
                </tr>
              </thead>
              <tbody>
                {allInquiries && allInquiries.map((inquiry) => (
                  <tr>
                    <td>{inquiry.inquiry_unique_id}</td>
                    <td>
                      <h4>{inquiry.company_name ? inquiry.company_name : "-"}</h4>
                      <div className="d-flex justify-content-between">
                        {
                            (inquiry?.country_to || inquiry?.country_from) && <p className="text-muted">
                          <svg
                            version="1.1"
                            id="fi_747340"
                            x="0px"
                            y="0px"
                            viewBox="0 0 512 512"
                            height={"18px"}
                            width={"18px"}
                            fill="#585858"
                          >
                            <g>
                              <g>
                                <path
                                  d="M256,110.062c-52.412,0-95.053,42.641-95.053,95.053s42.641,95.053,95.053,95.053s95.053-42.641,95.053-95.053
                                    S308.413,110.062,256,110.062z M256,260.146c-30.344,0-55.031-24.687-55.031-55.031s24.687-55.031,55.031-55.031
                                    s55.031,24.687,55.031,55.031S286.344,260.146,256,260.146z"
                                ></path>
                              </g>
                            </g>
                            <g>
                              <g>
                                <path
                                  d="M256,0C142.899,0,50.885,92.015,50.885,205.115v5.67c0,57.2,32.794,123.856,97.474,198.113
                                    c46.888,53.832,93.121,91.368,95.065,92.94L256,512l12.576-10.161c1.945-1.572,48.178-39.108,95.065-92.94
                                    c64.679-74.258,97.474-140.913,97.474-198.113v-5.67C461.115,92.015,369.101,0,256,0z M421.093,210.786
                                    c0,96.665-124.551,213.68-165.093,249.202C215.447,424.455,90.907,307.444,90.907,210.786v-5.67
                                    c0-91.032,74.061-165.093,165.093-165.093s165.093,74.061,165.093,165.093V210.786z"
                                ></path>
                              </g>
                            </g>
                          </svg>
                          <span className="mx-1">
                            { !isEmpty(inquiry.country_to) ? inquiry.country_to : inquiry.country_from}
                          </span>
                        </p>
                        }
                       
                      </div>
                    </td>
                    <td>
                      {(isSuperAdmin || isAdmin || isInqUser) ? (
                        <div className="py-2 inquiry-assign">
                          {!isEmpty(inquiry.assign_to_names) ? (
                            <>
                              {inquiry.assign_to_names && (size(inquiry.assign_to_names) == 1 ? join(inquiry.assign_to_names, ",") : inquiry.assign_to_names[0] + ` + ` + (size(inquiry.assign_to_names) - 1) + ` more`)}
                            </>
                          ) : (
                            <span className=" badge bg-danger">
                              Not Assigned
                            </span>
                          )}
                        </div>
                      ) : "-"}
                    </td>
                    <td>
                      {inquiry.created_at ? (
                        <>
                          {convertUTCToTzDate(inquiry.created_at, 'Etc/UTC', 'YYYY-MM-DD hh:mm A')}<ToolipsCustom subtitle="Universal Time Coordinated" title={"UTC"}></ToolipsCustom>
                        </>
                      ) : (
                        <></>
                      )}
                    </td>
                    <td>
                      <div className="">
                        <p className="d-flex align-items-center gap-2 mt-1">
                          <svg
                            version="1.1"
                            id="fi_266134"
                            x="0px"
                            y="0px"
                            viewBox="0 0 512 512"
                            height={"18px"}
                            width={"18px"}
                            fill="#585858"
                          >
                            <g>
                              <g>
                                <path
                                  d="M333.187,237.405c32.761-23.893,54.095-62.561,54.095-106.123C387.282,58.893,328.389,0,256,0
                                S124.718,58.893,124.718,131.282c0,43.562,21.333,82.23,54.095,106.123C97.373,268.57,39.385,347.531,39.385,439.795
                                c0,39.814,32.391,72.205,72.205,72.205H400.41c39.814,0,72.205-32.391,72.205-72.205
                                C472.615,347.531,414.627,268.57,333.187,237.405z M164.103,131.282c0-50.672,41.225-91.897,91.897-91.897
                                s91.897,41.225,91.897,91.897S306.672,223.18,256,223.18S164.103,181.954,164.103,131.282z M400.41,472.615H111.59
                                c-18.097,0-32.82-14.723-32.82-32.821c0-97.726,79.504-177.231,177.231-177.231s177.231,79.504,177.231,177.231
                                C433.231,457.892,418.508,472.615,400.41,472.615z"
                                ></path>
                              </g>
                            </g>
                          </svg>
                          {inquiry.contact_person ? inquiry.contact_person : "-"}
                        </p>
                        <p className="d-flex align-items-center gap-2 mt-1">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            id="fi_2907765"
                            data-name="Layer 1"
                            viewBox="0 0 24 24"
                            width="18"
                            height="18"
                            fill="#585858"
                          >
                            <path d="M20,19.75H4A2.76,2.76,0,0,1,1.25,17V7A2.76,2.76,0,0,1,4,4.25H20A2.76,2.76,0,0,1,22.75,7V17A2.76,2.76,0,0,1,20,19.75ZM4,5.75A1.25,1.25,0,0,0,2.75,7V17A1.25,1.25,0,0,0,4,18.25H20A1.25,1.25,0,0,0,21.25,17V7A1.25,1.25,0,0,0,20,5.75Z"></path>
                            <path d="M12,13.35a3.25,3.25,0,0,1-1.65-.45L1.62,7.71a.76.76,0,0,1-.27-1,.74.74,0,0,1,1-.26l8.74,5.18a1.69,1.69,0,0,0,1.76,0l8.74-5.18a.74.74,0,0,1,1,.26.76.76,0,0,1-.27,1L13.65,12.9A3.25,3.25,0,0,1,12,13.35Z"></path>
                          </svg>
                          {inquiry.email ? inquiry.email : "-"}
                        </p>
                        <p className="d-flex align-items-center gap-2 my-1">
                          <svg
                            height="18"
                            viewBox="-106 0 469 469.33333"
                            width="18"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="#585858"
                            id="fi_1551230"
                          >
                            <path d="m206.246094 0h-156.160156c-27.558594.03125-49.890626 22.363281-49.917969 49.921875v369.492187c.027343 27.558594 22.359375 49.890626 49.917969 49.917969h156.160156c27.558594-.027343 49.890625-22.359375 49.921875-49.917969v-369.492187c-.03125-27.558594-22.363281-49.890625-49.921875-49.921875zm28.585937 419.414062c-.015625 15.78125-12.804687 28.570313-28.585937 28.585938h-156.160156c-15.78125-.015625-28.570313-12.804688-28.585938-28.585938v-369.492187c.015625-15.785156 12.804688-28.574219 28.585938-28.589844h156.160156c15.78125.015625 28.570312 12.804688 28.585937 28.589844zm0 0"></path>
                            <path d="m160.167969 42.667969h-64c-5.890625 0-10.667969 4.773437-10.667969 10.664062s4.777344 10.667969 10.667969 10.667969h64c5.890625 0 10.664062-4.777344 10.664062-10.667969s-4.773437-10.664062-10.664062-10.664062zm0 0"></path>
                            <path d="m149.5 405.332031c0 11.785157-9.550781 21.335938-21.332031 21.335938-11.785157 0-21.335938-9.550781-21.335938-21.335938 0-11.78125 9.550781-21.332031 21.335938-21.332031 11.78125 0 21.332031 9.550781 21.332031 21.332031zm0 0"></path>
                          </svg>
                          {inquiry.phone ? inquiry.phone : "-"}
                        </p>
                      </div>
                    </td>
                    <td>
                      <p>
                        {inquiry.type &&
                          trim(inquiry.type) === "Logistic_Partner"
                          ? "Logistic Partner"
                          : inquiry.type}
                      </p>
                    </td>
                    <td>
                      <div className="d-flex gap-2">
                        {
                          (isSuperAdmin || isInqUser) ? <Link  className="d-flex align-items-center" to={`/${getPrefix(user)}${buildPath(privateRoutePaths.VIEW_LOGISTIC_INQUIRY, {
                            id: inquiry.inquiry_unique_id
                          })}`}>
                          <div className="fa-regular fa-eye icon-eyes border-0 panle-icon" title="View"></div>
                          </Link> 
                          : <div className="fa-regular fa-eye icon-eyes border-0 panle-icon" onClick={() => handlePopupShow(inquiry)} title="View"></div>
                        }

                        
                        {
                          (isSuperAdmin || isInqUser) && <div to="" className="fa-solid fa-trash-can icon-trash border-0 " title="Delete" onClick={() => handleDeleteInquiry(inquiry)}></div>
                        }

                      </div>
                    </td>
                  </tr>
                ))}

                {isEmpty(allInquiries) && (
                  <tr>
                    <td colSpan={7}>
                      <div className="text-center mt-3 mb-3">Inquiries not found</div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>

          </div>
        </div>

        <div className="row my-4" style={{ display: "none" }}>
          {allInquiries &&
            allInquiries.map((inquiry) => (

              <div className=" col-xxl-4 col-xl-6 col-lg-6 col-md-12 inquiry-box-main">
                <div className={"card shadow " + (isSuperAdmin ? 'inquiry-box-wraper' : 'user-inquiry-box-wraper')}>
                  <div className="card-body ">
                    <div className="inquiry-box-heading">
                      <div className="inquiry-card-heading">
                        <h4>{inquiry.company_name ? inquiry.company_name : "-"}</h4>
                        <div className="d-flex justify-content-between">
                          <p className="text-muted">
                            <svg
                              version="1.1"
                              id="fi_747340"
                              x="0px"
                              y="0px"
                              viewBox="0 0 512 512"
                              height={"18px"}
                              width={"18px"}
                              fill="#585858"
                            >
                              <g>
                                <g>
                                  <path
                                    d="M256,110.062c-52.412,0-95.053,42.641-95.053,95.053s42.641,95.053,95.053,95.053s95.053-42.641,95.053-95.053
                                        S308.413,110.062,256,110.062z M256,260.146c-30.344,0-55.031-24.687-55.031-55.031s24.687-55.031,55.031-55.031
                                        s55.031,24.687,55.031,55.031S286.344,260.146,256,260.146z"
                                  ></path>
                                </g>
                              </g>
                              <g>
                                <g>
                                  <path
                                    d="M256,0C142.899,0,50.885,92.015,50.885,205.115v5.67c0,57.2,32.794,123.856,97.474,198.113
                                        c46.888,53.832,93.121,91.368,95.065,92.94L256,512l12.576-10.161c1.945-1.572,48.178-39.108,95.065-92.94
                                        c64.679-74.258,97.474-140.913,97.474-198.113v-5.67C461.115,92.015,369.101,0,256,0z M421.093,210.786
                                        c0,96.665-124.551,213.68-165.093,249.202C215.447,424.455,90.907,307.444,90.907,210.786v-5.67
                                        c0-91.032,74.061-165.093,165.093-165.093s165.093,74.061,165.093,165.093V210.786z"
                                  ></path>
                                </g>
                              </g>
                            </svg>

                            <span className="mx-1">
                              {inquiry.type == "Supplier"
                                ? inquiry.country
                                : inquiry.country_to}
                            </span>



                          </p>
                          <span className="mx-1 text-muted">
                            Inquiry ID:
                            <span className="mx-1 text-orex-id"> {inquiry.inquiry_unique_id}</span>
                          </span>

                        </div>
                      </div>
                    </div>

                    <div className="inquiry-box-content">
                      <p className="d-flex align-items-center gap-2 mt-2">
                        <svg
                          version="1.1"
                          id="fi_266134"
                          x="0px"
                          y="0px"
                          viewBox="0 0 512 512"
                          height={"18px"}
                          width={"18px"}
                          fill="#585858"
                        >
                          <g>
                            <g>
                              <path
                                d="M333.187,237.405c32.761-23.893,54.095-62.561,54.095-106.123C387.282,58.893,328.389,0,256,0
                                S124.718,58.893,124.718,131.282c0,43.562,21.333,82.23,54.095,106.123C97.373,268.57,39.385,347.531,39.385,439.795
                                c0,39.814,32.391,72.205,72.205,72.205H400.41c39.814,0,72.205-32.391,72.205-72.205
                                C472.615,347.531,414.627,268.57,333.187,237.405z M164.103,131.282c0-50.672,41.225-91.897,91.897-91.897
                                s91.897,41.225,91.897,91.897S306.672,223.18,256,223.18S164.103,181.954,164.103,131.282z M400.41,472.615H111.59
                                c-18.097,0-32.82-14.723-32.82-32.821c0-97.726,79.504-177.231,177.231-177.231s177.231,79.504,177.231,177.231
                                C433.231,457.892,418.508,472.615,400.41,472.615z"
                              ></path>
                            </g>
                          </g>
                        </svg>

                        {inquiry.contact_person ? inquiry.contact_person : "-"}
                      </p>
                      <p className="d-flex align-items-center gap-2 mt-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          id="fi_2907765"
                          data-name="Layer 1"
                          viewBox="0 0 24 24"
                          width="18"
                          height="18"
                          fill="#585858"
                        >
                          <path d="M20,19.75H4A2.76,2.76,0,0,1,1.25,17V7A2.76,2.76,0,0,1,4,4.25H20A2.76,2.76,0,0,1,22.75,7V17A2.76,2.76,0,0,1,20,19.75ZM4,5.75A1.25,1.25,0,0,0,2.75,7V17A1.25,1.25,0,0,0,4,18.25H20A1.25,1.25,0,0,0,21.25,17V7A1.25,1.25,0,0,0,20,5.75Z"></path>
                          <path d="M12,13.35a3.25,3.25,0,0,1-1.65-.45L1.62,7.71a.76.76,0,0,1-.27-1,.74.74,0,0,1,1-.26l8.74,5.18a1.69,1.69,0,0,0,1.76,0l8.74-5.18a.74.74,0,0,1,1,.26.76.76,0,0,1-.27,1L13.65,12.9A3.25,3.25,0,0,1,12,13.35Z"></path>
                        </svg>
                        {inquiry.email ? inquiry.email : "-"}
                      </p>
                      <p className="d-flex align-items-center gap-2 my-2">
                        <svg
                          height="18"
                          viewBox="-106 0 469 469.33333"
                          width="18"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="#585858"
                          id="fi_1551230"
                        >
                          <path d="m206.246094 0h-156.160156c-27.558594.03125-49.890626 22.363281-49.917969 49.921875v369.492187c.027343 27.558594 22.359375 49.890626 49.917969 49.917969h156.160156c27.558594-.027343 49.890625-22.359375 49.921875-49.917969v-369.492187c-.03125-27.558594-22.363281-49.890625-49.921875-49.921875zm28.585937 419.414062c-.015625 15.78125-12.804687 28.570313-28.585937 28.585938h-156.160156c-15.78125-.015625-28.570313-12.804688-28.585938-28.585938v-369.492187c.015625-15.785156 12.804688-28.574219 28.585938-28.589844h156.160156c15.78125.015625 28.570312 12.804688 28.585937 28.589844zm0 0"></path>
                          <path d="m160.167969 42.667969h-64c-5.890625 0-10.667969 4.773437-10.667969 10.664062s4.777344 10.667969 10.667969 10.667969h64c5.890625 0 10.664062-4.777344 10.664062-10.667969s-4.773437-10.664062-10.664062-10.664062zm0 0"></path>
                          <path d="m149.5 405.332031c0 11.785157-9.550781 21.335938-21.332031 21.335938-11.785157 0-21.335938-9.550781-21.335938-21.335938 0-11.78125 9.550781-21.332031 21.335938-21.332031 11.78125 0 21.332031 9.550781 21.332031 21.332031zm0 0"></path>
                        </svg>

                        {inquiry.phone ? inquiry.phone : "-"}
                      </p>

                      {(isSuperAdmin || isInqUser) && (
                        <div className="py-2 inquiry-assign">
                          {!isEmpty(inquiry.assign_to_names) ? (
                            <>
                              <div className="d-flex align-items-center my-2">
                                <h4 className="badge bg-success text-light py-1 px-2">
                                  Assigned To
                                </h4>
                                <span className="ms-2">
                                  {

                                  }
                                  {inquiry.assign_to_names && (size(inquiry.assign_to_names) == 1 ? join(inquiry.assign_to_names, ",") : inquiry.assign_to_names[0] + ` + ` + (size(inquiry.assign_to_names) - 1) + ` more`)}
                                </span>
                              </div>

                              { /* <div className="d-flex align-items-center">
                                <h4 className="badge bg-success from text-light py-1 px-2">
                                  Assigned From
                                </h4>
                                <span className="ms-2"> </span> */}
                              {/* {inquiry.company_name} */}
                              {/* inquiry.assign_from_names && inquiry.assign_from_names[0]}
                                </span>
                              </div> */}



                            </>
                          ) : (
                            <span className=" badge bg-danger">
                              Not Assigned
                            </span>
                          )}
                        </div>
                      )}

                      <div className="py-2 inquiry-assign">
                        {inquiry.created_at ? (
                          <>
                            <div className="d-flex align-items-center">
                              <strong>Created At</strong>
                              <span className="ms-2">
                                {convertUTCToTzDate(inquiry.created_at, 'Etc/UTC', 'YYYY-MM-DD hh:mm A')}<ToolipsCustom subtitle="Universal Time Coordinated" title={"UTC"}></ToolipsCustom>
                              </span>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>

                    </div>
                  </div>

                  <div className="card-footer border-top d-flex align-items-center justify-content-between">
                    <p className="inquiry-supplier">
                      {inquiry.type &&
                        trim(inquiry.type) === "Logistic_Partner"
                        ? "Logistic Partner"
                        : inquiry.type}
                    </p>
                    <button
                      type="button"
                      onClick={() => handlePopupShow(inquiry)}
                      className="btn-regi"
                    >
                      View Inquiry Details
                    </button>
                  </div>
                </div>
              </div>
            ))}

          {isEmpty(allInquiries) && (
            <div className="me-5">
              <div className=" col-12 bg-white shadow rounded border-0 pt-4">
                <NoDataFound />
              </div>
            </div>

          )}
        </div>

        <div className="d-flex justify-content-between inquiry-pagination mt-3">
          {pagination.total > 0 && (<>
            <p>
              showing <b>{pagination.from}</b> to <b>{pagination.to}</b> of <b>{pagination.total}</b>
            </p>

            <ReactPaginate
              key={tableKey}
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={2}
              marginPagesDisplayed={2}
              pageCount={pageCount}
              previousLabel="<"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active"
              renderOnZeroPageCount={null}
            />
          </>
          )}
        </div>

      </div>

      {/** Inquiry Detail Pop-up Start */}
      <MediumPopup
        // title={`Inquiry Details - ${
        //   selectedInquiry ? selectedInquiry.company_name : ""
        // } - ${
        //   selectedInquiry && selectedInquiry.type == "Supplier"
        //     ? "(Supplier)"
        //     : "(Logistic Partner)"
        // }`}
        title={`Inquiry Details - ${selectedInquiry && selectedInquiry.type == "Supplier"
          ? "(Supplier)"
          : "(Logistic Partner)"
          }`}
        // title="Inquiry Details"
        mediummodalShow={mediummodalShow}
        setMediumModalShow={setMediumModalShow}
      // closeButtonLabel="Cancel"
      // okButtonLabel="Submit"
      // onSubmit={handleInquirySubmit}
      >
        <form onSubmit={handleInquirySubmit}>
          {selectedInquiry && (
            <div className="inquiry-details-popup">

              <div className="row g-0 justify-content-between inquiry-details-content mt-2">

                {(selectedInquiry && selectedInquiry.company_name) && (
                  <div className="row gs-3 p-0 col-xl-12 col-lg-12 border inquiry-from-box">

                    <div className="col-xl-12 p-0 inquiry-from">
                      <p> From </p>
                    </div>

                    <div className="col-xl-6 gx-4">
                      <div>
                        <p className="inquiry-detials-info">
                          {" "}
                          {/* {selectedInquiry && console.log(">>>>>>>>>>> ", selectedInquiry.assign_from)} */}
                          <b>Company Name:</b> {selectedInquiry.company_name && !isEmpty(selectedInquiry.assign_from) && selectedInquiry.assign_from[0].assign_from ? (
                            <Link to={`/${getPrefix()}${buildPath(privateRoutePaths.VIEW_COMPANY_PROFILE, {
                              id: selectedInquiry.assign_from[0].assign_from
                            })}`} target="_blank"> {selectedInquiry.company_name}</Link>
                          ) : (
                            <span>{selectedInquiry.company_name}</span>
                          )}{" "}
                        </p>
                      </div>
                    </div>

                    <div className="col-xl-6 gx-4">
                      <div>
                        <p>
                          {" "}
                          <b>Contact Person:</b> {selectedInquiry.contact_person}{" "}
                        </p>
                      </div>
                    </div>

                    <div className="col-xl-6 gx-4">
                      <div>
                        <p>
                          {" "}
                          <b>Email: </b>
                          {selectedInquiry.email}{" "} {selectedInquiry.other_email ? ', ' + selectedInquiry.other_email : ""}
                        </p>
                      </div>
                    </div>


                    <div className="col-xl-6 gx-4">
                      <div>
                        <p>
                          <b>Phone Number:</b> {!isEmpty(selectedInquiry.phone) ? selectedInquiry.phone : ' - '}{" "}
                        </p>
                      </div>
                    </div>
                  </div>
                )}


              </div>

              <div className="row g-0 justify-content-between border g-0 mt-2 inquiry-information-box ">

                <div className="col-xl-12 p-0 inquiry-information text-center">
                  <p>Inquiry information</p>
                </div>


                 {selectedInquiry.type === "Logistic_Partner" && (
                <>
                  {selectedInquiry.freight_type == "Air" && (
                    <>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>Freight type:</b> {selectedInquiry.freight_type}
                          </p>
                        </div>
                      </div>
                      <div className="col-xl-6 gx-4"></div>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            {" "}
                            <b>Origin Country:</b>
                            {selectedInquiry.country_from}
                          </p>
                        </div>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>Origin Airport:</b>
                            {selectedInquiry.port_of_origin}
                          </p>
                        </div>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>Destination Country:</b>
                            {selectedInquiry.country_to}
                          </p>
                        </div>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>Destination Airport:</b>{" "}
                            {selectedInquiry.port_of_destination}
                          </p>
                        </div>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <p className="border-bottom-0">
                          <b>Commodity/Product:</b>{" "}
                          {selectedInquiry.commodity}{" "}
                        </p>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <p className="border-bottom-0">
                          <b>HS Code:</b> {selectedInquiry.hs_code}{" "}
                        </p>
                      </div>

                      {/* {!isEmpty(selectedInquiry.lwh_qty_cbpp) &&
                                                      map(selectedInquiry.lwh_qty_cbpp, (val) => {
                                                        return (
                                                          <p>
                                                            {val.lwh} {val.no_qty} {val.cbpp}
                                                          </p>
                                                        );
                                                      })}
                            
                                                    {isEmpty(selectedInquiry.lwh_qty_cbpp) && (
                                                      <>
                                                        <div className="col-xl-6 gx-4">
                                                          <p>
                                                            <b>Length/Width/Height (CM):</b>{" "}
                                                            {selectedInquiry.lwh}{" "}
                                                          </p>
                                                        </div>
                                                        <div className="col-xl-6 gx-4">
                                                          <p>
                                                            <b>Containers Type/Boxes/Pallat/Packages:</b>{" "}
                                                            {selectedInquiry.cbpp}{" "}
                                                          </p>
                                                        </div>
                                                      </>
                                                    )} */}
                      <div className="col-xl-12 gx-4 mt-4">
                        <div className="air-table-wrap">
                          <table className="air-table">
                            <thead>
                              <tr>
                                <th>Length/Width/Height (CM)</th>
                                <th>No/Qty</th>
                                <th>Type of Packaging</th>
                              </tr>
                            </thead>
                            <tbody>
                              {!isEmpty(selectedInquiry.lwh_qty_cbpp) &&
                                map(
                                  selectedInquiry.lwh_qty_cbpp,
                                  (val, index) => {
                                    return (
                                      <tr key={index}>
                                        <td>{val.lwh}</td>
                                        <td>{val.no_qty}</td>
                                        <td>{val.cbpp}</td>
                                      </tr>
                                    );
                                  },
                                )}

                              {isEmpty(selectedInquiry.lwh_qty_cbpp) && (
                                <tr>
                                  <td>
                                    <b>Length/Width/Height (CM):</b>{" "}
                                    {selectedInquiry.lwh}
                                  </td>
                                  <td></td>
                                  <td>
                                    <b>
                                      Containers Type/Boxes/Pallat/Packages:
                                    </b>{" "}
                                    {selectedInquiry.cbpp}
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="col-xl-6 gx-4">
                        <p>
                          <b>Total Weight (KG):</b>{" "}
                          {!isEmpty(selectedInquiry.total_weight)
                            ? selectedInquiry.total_weight
                            : " - "}{" "}
                        </p>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <p>
                          {" "}
                          <b>Term:</b> {selectedInquiry.term}{" "}
                        </p>
                      </div>

                      {selectedInquiry &&
                        !isEmpty(selectedInquiry.term) &&
                        showPickupAddress.includes(selectedInquiry.term) && (
                          <div className="col-xl-6 gx-4">
                            <p>
                              {" "}
                              <b>Pickup Address:</b>{" "}
                              {selectedInquiry.pickup_address}{" "}
                            </p>
                          </div>
                        )}
                      {selectedInquiry &&
                        !isEmpty(selectedInquiry.term) &&
                        showDeliveryAddress.includes(selectedInquiry.term) && (
                          <div className="col-xl-6 gx-4">
                            <p>
                              {" "}
                              <b>Delivery Address:</b>{" "}
                              {selectedInquiry.delivery_address}{" "}
                            </p>
                          </div>
                        )}
                      <div className="col-xl-6 gx-4">
                        <p>
                          {" "}
                          <b>Inquiry ID:</b>{" "}
                          {selectedInquiry.inquiry_unique_id}{" "}
                        </p>
                      </div>
                    </>
                  )}
                  {selectedInquiry.freight_type == "Road" && (
                    <>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>Freight type:</b> Road Transportation
                          </p>
                        </div>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>Cargo type:</b> {selectedInquiry.ocean_type}{" "}
                            {selectedInquiry.ocean_type == "FTL"
                              ? "(Full Truck Load)"
                              : "(Less Truck Load)"}
                          </p>
                        </div>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>Country From:</b>{" "}
                            {selectedInquiry.country_from
                              ? selectedInquiry.country_from
                              : "-"}
                          </p>
                        </div>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>Origin Port:</b>{" "}
                            {selectedInquiry.port_of_origin
                              ? selectedInquiry.port_of_origin
                              : "-"}
                          </p>
                        </div>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>Country To:</b>{" "}
                            {selectedInquiry.country_to
                              ? selectedInquiry.country_to
                              : "-"}
                          </p>
                        </div>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>Destination Port:</b>{" "}
                            {selectedInquiry.port_of_destination
                              ? selectedInquiry.port_of_destination
                              : "-"}
                          </p>
                        </div>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>Commodity:</b>{" "}
                            {selectedInquiry.commodity
                              ? selectedInquiry.commodity
                              : "-"}
                          </p>
                        </div>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>HS code:</b>{" "}
                            {selectedInquiry.hs_code
                              ? selectedInquiry.hs_code
                              : "-"}
                          </p>
                        </div>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>No of Containers/Vehicles:</b>{" "}
                            {selectedInquiry.no_of_containers
                              ? selectedInquiry.no_of_containers
                              : "-"}
                          </p>
                        </div>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>Containers Type:</b>{" "}
                            {selectedInquiry.cbpp ? selectedInquiry.cbpp : "-"}
                          </p>
                        </div>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>Total Weight:</b>{" "}
                            {selectedInquiry.total_weight
                              ? selectedInquiry.total_weight
                              : "-"}
                          </p>
                        </div>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>Term:</b>{" "}
                            {selectedInquiry.term ? selectedInquiry.term : "-"}
                          </p>
                        </div>
                      </div>
                      {!isEmpty(selectedInquiry.term) &&
                        showPickupAddress.includes(selectedInquiry.term) && (
                          <div className="col-xl-6 gx-4">
                            <p>
                              <b>Pickup Address:</b>{" "}
                              {selectedInquiry.pickup_address}
                            </p>
                          </div>
                        )}
                      {((!isEmpty(selectedInquiry.term) &&
                        showDeliveryAddress.includes(selectedInquiry.term)) ||
                        selectedInquiry.freight_type === "DAP") && (
                        <div className="col-xl-6 gx-4">
                          <p>
                            <b>Delivery Address:</b>{" "}
                            {selectedInquiry.delivery_address}
                          </p>
                        </div>
                      )}
                      <div className="col-xl-6 gx-4">
                        <p>
                          {" "}
                          <b>Inquiry ID:</b>{" "}
                          {!isEmpty(selectedInquiry.inquiry_unique_id)
                            ? selectedInquiry.inquiry_unique_id
                            : " - "}{" "}
                        </p>
                      </div>
                    </>
                  )}

                  {selectedInquiry.freight_type == "DAP" && (
                    <>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>Freight type:</b> DAP Services
                          </p>
                        </div>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>Cargo type:</b>{" "}
                            {selectedInquiry.ocean_type == "Project_Cargo"
                              ? "Project Cargo"
                              : selectedInquiry.ocean_type == "DAG_GOODS"
                                ? "Dangerous Goods"
                                : selectedInquiry.ocean_type == "LCL_FCL"
                                  ? "LCL & FCL Both"
                                  : selectedInquiry.ocean_type}{" "}
                            {selectedInquiry.ocean_type == "FCL"
                              ? "(Full Container Load)"
                              : ""}
                            {selectedInquiry.ocean_type == "LCL"
                              ? "(Less Container Load)"
                              : ""}
                          </p>
                        </div>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>Country:</b> {selectedInquiry.country_from}
                          </p>
                        </div>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>Port:</b> {selectedInquiry.port_of_origin}
                          </p>
                        </div>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>
                              {selectedInquiry.ocean_type == "Ro-Ro"
                                ? "Commodity/Product"
                                : "Commodity"}
                              :
                            </b>{" "}
                            {selectedInquiry.commodity}
                          </p>
                        </div>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>Hs Code:</b>{" "}
                            {!isEmpty(selectedInquiry.hs_code)
                              ? `${selectedInquiry.hs_code} `
                              : "-"}
                          </p>
                        </div>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>
                              {selectedInquiry.ocean_type == "FCL" ||
                              selectedInquiry.ocean_type == "LCL" ||
                              selectedInquiry.ocean_type == "DAG_GOODS"
                                ? "No of Containers: "
                                : ""}
                              {selectedInquiry.ocean_type == "Ro-Ro"
                                ? "No of Units: "
                                : ""}
                              {selectedInquiry.ocean_type == "Project_Cargo"
                                ? "No of Pieces: "
                                : ""}
                              :
                            </b>{" "}
                            {selectedInquiry.no_of_containers
                              ? selectedInquiry.no_of_containers
                              : "-"}
                          </p>
                        </div>
                      </div>
                      {selectedInquiry.ocean_type != "Ro-Ro" &&
                        selectedInquiry.ocean_type != "Project_Cargo" && (
                          <div className="col-xl-6 gx-4">
                            <div>
                              <p>
                                <b>
                                  {selectedInquiry.ocean_type == "DAG_GOODS" ||
                                  selectedInquiry.ocean_type == "LCL"
                                    ? "Type of Packaging: "
                                    : ""}
                                  {selectedInquiry.ocean_type == "FCL"
                                    ? "Type of Container: "
                                    : ""}
                                  :
                                </b>{" "}
                                {selectedInquiry.cbpp && selectedInquiry.cbpp}
                              </p>
                            </div>
                          </div>
                        )}
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>Total Weight (KG):</b>{" "}
                            {!isEmpty(selectedInquiry.total_weight)
                              ? selectedInquiry.total_weight
                              : " - "}
                          </p>
                        </div>
                      </div>
                      {selectedInquiry.term && (
                        <div className="col-xl-6 gx-4">
                          <p>
                            <b>Term:</b> {selectedInquiry.term}
                          </p>
                        </div>
                      )}
                      {!isEmpty(selectedInquiry.term) &&
                        showPickupAddress.includes(selectedInquiry.term) && (
                          <div className="col-xl-6 gx-4">
                            <p>
                              <b>Pickup Address:</b>{" "}
                              {selectedInquiry.pickup_address}
                            </p>
                          </div>
                        )}
                      {((!isEmpty(selectedInquiry.term) &&
                        showDeliveryAddress.includes(selectedInquiry.term)) ||
                        selectedInquiry.freight_type === "DAP") && (
                        <div className="col-xl-6 gx-4">
                          <p>
                            <b>Delivery Address:</b>{" "}
                            {selectedInquiry.delivery_address}
                          </p>
                        </div>
                      )}
                      <div className="col-xl-6 gx-4">
                        <p>
                          {" "}
                          <b>Inquiry ID:</b>{" "}
                          {!isEmpty(selectedInquiry.inquiry_unique_id)
                            ? selectedInquiry.inquiry_unique_id
                            : " - "}{" "}
                        </p>
                      </div>
                    </>
                  )}

                  {selectedInquiry.freight_type == "Ocean" && (
                    <>
                      <div className="col-xl-6 gx-4">
                        <div>
                          <p>
                            <b>Freight type:</b> Sea Freight
                          </p>
                        </div>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <p>
                          <b>Cargo type:</b>{" "}
                          {selectedInquiry.ocean_type == "Project_Cargo"
                            ? "Project Cargo"
                            : selectedInquiry.ocean_type == "DAG_GOODS"
                              ? "Dangerous Goods"
                              : selectedInquiry.ocean_type == "LCL_FCL"
                                ? "LCL & FCL Both"
                                : selectedInquiry.ocean_type}{" "}
                          {selectedInquiry.ocean_type == "FCL"
                            ? "(Full Container Load)"
                            : ""}
                          {selectedInquiry.ocean_type == "LCL"
                            ? "(Less Container Load)"
                            : ""}
                        </p>
                      </div>

                      <div className="col-xl-6 gx-4">
                        <p>
                          <b>Country From:</b> {selectedInquiry.country_from}
                        </p>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <p>
                          <b>Origin Port:</b> {selectedInquiry.port_of_origin}
                        </p>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <p>
                          <b>Country To:</b> {selectedInquiry.country_to}
                        </p>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <p>
                          <b>Destination Port:</b>{" "}
                          {selectedInquiry.port_of_destination}
                        </p>
                      </div>
                      <div className="col-xl-6 gx-4">
                        {selectedInquiry.ocean_type == "Ro-Ro" ||
                        selectedInquiry.ocean_type == "LCL_FCL" ? (
                          <p>
                            <b>Commodity/Product: </b>{" "}
                            {selectedInquiry.commodity}
                          </p>
                        ) : (
                          <p>
                            <b>Commodity: </b> {selectedInquiry.commodity}
                          </p>
                        )}
                      </div>
                      <div className="col-xl-6 gx-4">
                        <p>
                          <b>Hs Code:</b>{" "}
                          {!isEmpty(selectedInquiry.hs_code)
                            ? `${selectedInquiry.hs_code} `
                            : "-"}
                        </p>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <p>
                          <b>
                            {selectedInquiry.ocean_type == "FCL" ||
                            selectedInquiry.ocean_type == "LCL" ||
                            selectedInquiry.ocean_type == "DAG_GOODS"
                              ? "No of Containers: "
                              : ""}
                            {selectedInquiry.ocean_type == "Ro-Ro"
                              ? "No of Units: "
                              : ""}
                            {selectedInquiry.ocean_type == "Project_Cargo"
                              ? "No of Pieces: "
                              : ""}
                            {selectedInquiry.ocean_type == "LCL_FCL"
                              ? "No of Containers: "
                              : ""}
                            {selectedInquiry.ocean_type == "Bulk"
                              ? "Cargo Qty: "
                              : ""}
                          </b>

                          {selectedInquiry.no_of_containers &&
                            selectedInquiry.no_of_containers}
                        </p>
                      </div>
                      {selectedInquiry.ocean_type != "Ro-Ro" && (
                        <div className="col-xl-6 gx-4">
                          <p>
                            <b>
                              {selectedInquiry.ocean_type == "DAG_GOODS" ||
                              selectedInquiry.ocean_type == "LCL" ||
                              selectedInquiry.ocean_type == "Project_Cargo"
                                ? "Type of Packaging: "
                                : ""}
                              {selectedInquiry.ocean_type == "FCL"
                                ? "Type of Container: "
                                : ""}
                              {selectedInquiry.ocean_type == "LCL_FCL"
                                ? "Type of packaging/container: "
                                : ""}
                              {selectedInquiry.ocean_type == "Bulk"
                                ? "Type of product: "
                                : ""}
                            </b>
                            {selectedInquiry.cbpp && selectedInquiry.cbpp}
                          </p>
                        </div>
                      )}
                      <div className="col-xl-6 gx-4">
                        <p>
                          <b>Total Weight (KG):</b>{" "}
                          {!isEmpty(selectedInquiry.total_weight)
                            ? selectedInquiry.total_weight
                            : " - "}
                        </p>
                      </div>
                      <div className="col-xl-6 gx-4">
                        <p>
                          <b>Term:</b> {selectedInquiry.term}
                        </p>
                      </div>
                      {!isEmpty(selectedInquiry.term) &&
                        showPickupAddress.includes(selectedInquiry.term) && (
                          <div className="col-xl-6 gx-4">
                            <p>
                              <b>Pickup Address:</b>{" "}
                              {selectedInquiry.pickup_address}
                            </p>
                          </div>
                        )}
                      {((!isEmpty(selectedInquiry.term) &&
                        showDeliveryAddress.includes(selectedInquiry.term)) ||
                        selectedInquiry.freight_type === "DAP") && (
                        <div className="col-xl-4 gx-4">
                          <p>
                            <b>Delivery Address:</b>{" "}
                            {selectedInquiry.delivery_address}
                          </p>
                        </div>
                      )}
                      <div className="col-xl-6 gx-4">
                        <p>
                          {" "}
                          <b>Inquiry ID:</b>{" "}
                          {!isEmpty(selectedInquiry.inquiry_unique_id)
                            ? selectedInquiry.inquiry_unique_id
                            : " - "}{" "}
                        </p>
                      </div>
                    </>
                  )}
                  <div className="col-xl-12 gx-4 ck-massage ck-edit-cntnt">
                    <div>
                      <div
                        className="border-0"
                        dangerouslySetInnerHTML={{
                          __html: `<p className="border-0" style="border-bottom: 0px solid #f3f3f3 !important"><b>Remark:</b>${!isEmpty(selectedInquiry.message) ? selectedInquiry.message : " - "}</p> `,
                        }}
                      />
                    </div>
                  </div>
                </>
              )}

              </div>

              {(selectedInquiry.doc1 || selectedInquiry.doc2 || selectedInquiry.doc3 || selectedInquiry.doc4 || selectedInquiry.doc5) &&

                <div className="col-xl-12 mt-3 mb-3">
                  <div className="d-flex flex-wrap gap-2 attachment-btn-wrape">
                    {selectedInquiry.doc1 &&
                      <a className="btn btn-primary" onClick={() => handleDownload(PATH + selectedInquiry.doc1)}>
                        <i className="fa fa-paperclip"></i> Attachment 1
                      </a>
                    }
                    {selectedInquiry.doc2 &&
                      <a className="btn btn-primary" onClick={() => handleDownload(PATH + selectedInquiry.doc2)}>
                        <i className="fa fa-paperclip"></i> Attachment 2
                      </a>
                    }
                    {selectedInquiry.doc3 &&
                      <a className="btn btn-primary" onClick={() => handleDownload(PATH + selectedInquiry.doc3)}>
                        <i className="fa fa-paperclip"></i> Attachment 3
                      </a>
                    }
                    {selectedInquiry.doc4 &&
                      <a className="btn btn-primary" onClick={() => handleDownload(PATH + selectedInquiry.doc4)}>
                        <i className="fa fa-paperclip"></i> Attachment 4
                      </a>
                    }
                    {selectedInquiry.doc5 &&
                      <a className="btn btn-primary" onClick={() => handleDownload(PATH + selectedInquiry.doc5)}>
                        <i className="fa fa-paperclip"></i> Attachment 5
                      </a>
                    }
                  </div>
                </div>
              }

              {(isSuperAdmin || isInqUser) && (

                <div className="row g-0 border my-3 inquiry-details-country">

                  <div className="col-xl-12">
                    <div className="row">
                      {selectedInquiry.assign_to !== null && (
                        <div className="col-xl-12">
                          <div className="input-group">
                            <p className="input-pad d-flex align-items-cetner">
                              <CheckBox
                                onChange={handleCheckChange}
                                checked={isChecked}
                              ></CheckBox>
                              <span className="ms-2">Change Assign Inquiry</span>
                            </p>
                          </div>
                        </div>
                      )}

                      {isChecked && (
                        <>
                          {
                            map(assignedCompanyAndCountry, (val, indx) => {
                              return (
                                <div className="row">
                                  <div className="col-xl-4 ">
                                    <div className="input-group">
                                      <label className="form-label required">
                                        Country
                                      </label>
                                      <div className="input-pad">
                                        <Select
                                          name="country_assign"
                                          options={countryList}
                                          value={assignedCompanyAndCountry[indx]['country'] ? assignedCompanyAndCountry[indx]['country'] : null}
                                          // onChange={handleCountryChange}
                                          onChange={(e) => handleAssignCountryChangeByIndex(e, indx)}
                                          placeholder="Select country"
                                          className="dd-pad"
                                          noOptionsMessage={() => "No Country Found"}
                                          menuPlacement="top"
                                        />

                                        {/* errors.country_assign && (
                                          <span
                                            className="company-required"
                                            style={styleError}
                                          >
                                            {errors.country_assign}
                                          </span>
                                        ) */}
                                        {
                                          errors.countryCompany && <span
                                            className="company-required"
                                            style={styleError}
                                          >
                                            {errors.countryCompany[indx]['country']}
                                          </span>
                                        }
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-xl-6 pe-0 ">
                                    <div className="input-group">
                                      <label className="form-label required">
                                        Company
                                      </label>
                                      <div className="input-pad">
                                        <div className="d-flex align-items-center w-100">
                                          <div className="w-100">

                                            <Select
                                              name="company"
                                              options={assignedCompanyAndCountry[indx]['companyList']}
                                              onInputChange={(e) => handleInputChangeByIndex(e, indx)}
                                              value={assignedCompanyAndCountry[indx]['company'] ? assignedCompanyAndCountry[indx]['company'] : null}
                                              // onChange={handleCompanyChange}
                                              onChange={(e) => handleAssignCompanyChangeByIndex(e, indx)}
                                              placeholder="Select company"
                                              className="dd-pad"
                                              noOptionsMessage={() => "No Company Found"}
                                              menuPlacement="top"
                                              filterOption={customFilter}
                                              isLoading={memberOptLoader}
                                            />



                                            {
                                              errors.countryCompany && <span
                                                className="company-required"
                                                style={styleError}
                                              >
                                                {errors.countryCompany[indx]['company']}
                                              </span>
                                            }
                                          </div>
                                          <ToolipsCustom
                                            title={"?"}
                                            subtitle={"Search Using Company Name, Email Id or Member Unique Number "}
                                          ></ToolipsCustom>

                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="col-xl-2 pe-0">
                                    <div className="d-flex" style={{ "marginTop": "30px" }}>
                                      <button type="button" onClick={handleAddClick} className="btn outlines">
                                        <i className="fa fa-plus"></i>
                                      </button>
                                      <button type="button" onClick={(e) => handleRemoveClick(e, indx)} className="btn outlines">
                                        <i className="fa fa-minus"></i>
                                      </button>
                                      {/* <Link to={`${assignedCompanyAndCountry[indx]['company'] ? getPrefix() + buildPath(privateRoutePaths.VIEW_COMPANY_PROFILE.path, {
                                        id: assignedCompanyAndCountry[indx]['company']['value']
                                      }) : null}`} href={`${assignedCompanyAndCountry[indx]['company'] ? getPrefix() + buildPath(privateRoutePaths.VIEW_COMPANY_PROFILE.path, {
                                        id: assignedCompanyAndCountry[indx]['company']['value']
                                      }) : null}`} target="_blank">
                                        <button type="button" >
                                          <i className="fa fa-info"></i>
                                        </button>
                                      </Link> */}

                                    </div>
                                  </div>


                                </div>
                              )
                            })
                          }

                          {
                            errors.company && (
                              <span
                                className="company-required"
                                style={styleError}
                              >
                                {errors.company}
                              </span>
                            )
                          }


                          <div className="col-xl-12 inquiry-form-btn ">
                            <ButtonCancell
                              className="inq-form-btn"
                              type="button"
                              // disabled={isButtonDisabled}
                              onClick={handleCancelClick}
                            >
                              {" "}
                              Cancel
                            </ButtonCancell>
                            <ButtonAdminpanel
                              type="submit"
                              className="inq-form-btn"
                              disabled={isButtonDisabled}
                            >
                              Assign
                            </ButtonAdminpanel>
                          </div>
                        </>
                      )}

                    </div>
                  </div>

                </div>
              )}

            </div>
          )}
        </form>
      </MediumPopup>

      {/** Inquiry Detail Pop-up End */}

      <MediumPopup title={`Add Inquiry`}
        mediummodalShow={inqModalShow}
        setMediumModalShow={setInqModalShow}>

        {inqType === "LOG_PTR" && <LogisticInquiry mediummodalShow={inqModalShow} setMediumModalShow={setInqModalShow} pageView="pop_up" fromPage="list" getData={getAllInquiries} limit={limit} current_page={current_page} searchFilterObj={searchFilterObj} />}

      </MediumPopup>

      {/** Delete Inquiry popup */}
      <SmallPopup
        title="Delete Inquiry"
        smallmodalShow={smallmodalShow}
        setSmallModalShow={setSmallModalShow}
        onSubmit={handleConfirmDeleteClick}
        closeButtonLabel="Cancel"
        okButtonLabel="Delete"
      >
        <div className='row my-3'>
          <div className="col-md-12 p-0">Are you sure you want to delete Inquiry?</div>
        </div>

      </SmallPopup>
    </div>
  );
};

const mapStateToProps = (state) => {
  // console.log('state -->', state);
  return {};
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAllInquiries: (limit, current_page, filterObj) =>
      dispatch(getAllAdminInquiries(limit, current_page, filterObj)),
    showLoading: () => dispatch(showLoading()),
    hideLoading: () => dispatch(hideLoading()),
    getCountryList: () => dispatch(getCountryList()),
    deleteInquiry: (InqId) => dispatch(deleteInquiry(InqId))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LogisticInquiries);